import { render, staticRenderFns } from "./FormThuxHorizontalCheckboxGroup.vue?vue&type=template&id=70c66f34&"
import script from "./FormThuxHorizontalCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports